<template>
  <!-- 黑名单列表 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)">
      <el-icon>
        <Plus />
      </el-icon>
      &nbsp;添加
    </el-button>
    <el-button type="primary" @click="editFnc($event)" class="edit" plain size="large"
            ><el-icon><EditPen /></el-icon>&nbsp;编辑</el-button
        >
    <el-button type="danger" size="large" @click="deleteFnc($event)"
      ><el-icon><DeleteFilled /></el-icon>&nbsp;删除
    </el-button>
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="BlackList"
    @update-list="updateList"
    excelName="黑名单列表"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @searchFnc="searchFnc"
    @handleSelection="handleSelection"
  >
  <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 黑名单 -->
  <el-dialog
    class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="600px"
    append-to-body="false"
    draggable
    destroy-on-close
  >
    <AddEditBlackList
      ref="AddEditComponent"
      v-if="addEditVisible"
      :edit-id="editId"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditBlackList>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import AddEditBlackList from "views/blackList/AddEditBlackList.vue";
import { reactive, onMounted, toRefs, ref, toRaw, h, computed,nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import store from "../../store/index";
import {
  getList,
  addBlackList,
  editBlackList,
  deleteBlackList,
} from "network/blackList.js";

export default {
  name: "BlackList",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditBlackList,
  },
  emits: ["addTab"],
  setup(props, { emit }) {

    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      // 登录状态
      AdminCache: computed(() => {
        return (
          store.state.AdminCache ||
          JSON.parse(sessionStorage.getItem("AdminCache"))
        );
      }),
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },
        {
          label: "IP地址",
          prop: "ipAddress",
          width: "280",
          align: "center",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "结束时间",
          prop: "endTimeDisplay",
          width: "300",
          align: "center",
          noSetText: "未设置",
          type: "DateSelect",
          valueFormat: 'YYYY-MM-DD HH:mm:ss',
          dateAndTime: true,
          dateType: "datetime",
          createTimeStart: '',
          createTimeEnd: '',
        },
        {
          label: "状态",
          prop: "statusDisplay",
          width: "200",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "是否有效",
          prop: "isActive",
          width: "200",
          align: "center",
          noSetText: "未设置",
          isTag: true,
          type: "SelectSearch",
          selectOptions: [{
            key: null,
            value: "是否有效(全部)"
          }, {
            key: true,
            value: "是"
          }, {
            key: false,
            value: "否"
          }],
        },
        {
          label: "原因",
          prop: "reason",
          width: "450",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
        },
         {
          label: "创建时间",
          prop: "createTimeDisplay",
          align: "center",
          noSetText: "未设置",
        },
      ],
      multipleSelection: [], //选中行数据
      //筛选项
      search: {
        ipAddress: null,
        reason: null,
        isActive: null,
        createTimeStart: null,
        createTimeEnd: null,
      },
      // 弹窗相关
      addEditVisible: false,
      editId: 0,
      dialogTitle: "",
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getBlackList(); //请求黑名单列表数据
    });

    // 获取列表
    const getBlackList = () => {
      data.loading = true;
      const obj = {
        page: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
        ipAddress: data.search.ipAddress,
        reason: data.search.reason,
        isActive: data.search.isActive,
        createTimeStart: data.search.createTimeStart,
        createTimeEnd: data.search.createTimeEnd,
      };
      getList(obj)
        .then((result) => {
          if (result && result.code == 1) {
            const list = result.result.items || [];
            data.pagination.total = result.result.allItemsCount || 0;
            data.tableData = list;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessageBox.alert(result.message || result.msg || "获取数据失败");
          }
        })
        .catch((err) => {
          data.loading = false;
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "ipAddress") {
        data.search.ipAddress = val.value;
      }
      if (val.prop && val.prop == "reason") {
        data.search.reason = val.value;
      }
      if (val.prop && val.prop == "isActive") {
        if (val.value !== "") {
          data.search.isActive = val.value;
        } else {
          data.search.isActive = null;
        }
      }
      if (val.prop && val.prop == "endTimeDisplay") {
        data.search.createTimeStart =val.value.start ? val.value.start : null;
        data.search.createTimeEnd = val.value.end ? val.value.end : null;
      }
      data.pagination.currentPage = 1;
      getBlackList();
    };

    // 分页改变
    const changePagination = (val) => {
      data.pagination.currentPage = val.currentPage;
      data.pagination.pageSize = val.pageSize;
      getBlackList();
    };

    // 选中行
    const handleSelection = (val) => {
      data.multipleSelection = val;
    };

    // 添加
    const addFnc = (e) => {
      data.editId = 0;
      data.dialogTitle = "添加黑名单";
      data.addEditVisible = true;
    };

    // 编辑
    const editFnc = (e) => {
      if (data.multipleSelection.length === 0) {
        ElMessage.warning("请选择要编辑的黑名单");
        return;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.warning("只能选择一条黑名单进行编辑");
        return;
      }
      data.editId = data.multipleSelection[0].id;
      data.dialogTitle = "编辑黑名单";
      data.addEditVisible = true;
    };

    // 删除
    const deleteFnc = (e) => {
      if (data.multipleSelection.length === 0) {
        ElMessage.warning("请选择要删除的数据");
        return;
      }
      if (data.multipleSelection.length > 1) {
        ElMessage.warning("只能选择一条黑名单进行删除");
        return;
      }
      ElMessageBox.confirm(
        `确定要删除选中的${data.multipleSelection.length}条黑名单记录吗？`,
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        const ids = data.multipleSelection.map(row => row.id);
        const id = ids[0]; // 取数组中的第一个id
        deleteBlackList(id).then((result) => {
          if (result && result.code == 1) {
            ElMessage.success("删除成功");
            getBlackList();
          } else {
            ElMessage.error(result.message || "删除失败");
          }
        }).catch((err) => {
          console.log(err);
          ElMessage.error("删除失败");
        });
      }).catch(() => {
        ElMessage.info("已取消删除");
      });
    };

    // 关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 弹窗关闭前的回调
     const handleClose = (done) => {
       done();
     };

     // 更新列表
     const updateList = () => {
       getBlackList();
     };
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      ...toRefs(data),
      searchFnc,
      changePagination,
      updateList,
      handleSelection,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      handleClose,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
     };
  },
};
</script>

<style scoped>

</style>